import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {EChartsOption} from 'echarts';
import {Observable} from 'rxjs';
import {ReportChannelAffinityStore} from '../../../../shared/store/report/report-channel-affinity.store';

@Component({
  selector: 'app-sankey',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss']
})
export class ChartComponent implements OnInit, AfterViewInit, OnDestroy {
  public readonly loading$: Observable<boolean> = this._reportChannelAffinityStore.loading$;
  public readonly report$: Observable<any> = this._reportChannelAffinityStore.report$;
  public readonly chartOption$: Observable<EChartsOption> = this._reportChannelAffinityStore.chartOption$;

  constructor(
    private readonly _reportChannelAffinityStore: ReportChannelAffinityStore
  ) { }

  ngOnInit(): void {}

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}

}
